import {USER_INITIALS_ICON_COLORS} from './constants'

export class UserInitialsIconColorPalette {
    constructor() {
        this.nextColorIndex = -1
    }

    getNextColor() {
        this.nextColorIndex = this.nextColorIndex < USER_INITIALS_ICON_COLORS.length - 1 ? this.nextColorIndex + 1 : 0
        return USER_INITIALS_ICON_COLORS[this.nextColorIndex]
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/comments/UserInitialsIconColorPalette.js